import * as React from 'react';

import { FormWidget, FormConfigurations } from 'kiini/Forms';
import TextField from 'kiini/TextField';
import LocaleField from 'kiini/LocaleField';
import LocationField from 'kiini/LocationField';
import BooleanField from 'kiini/BooleanField';
import OptionalOneOfField from 'kiini/OptionalOneOfField';
import SelectionChoicesField from 'kiini/SelectionChoicesField';

import ContentObjectRolesEditor from 'components/contentRoles/ContentObjectRolesEditor';

import TagsWidget from 'components/contentObjects/TagsWidget';

import { Copyrights, copyrightsClassDescription } from 'model/contentObjects';


const commonRunnableObjectBlockConfiguration = {
    groups: [
        {
            label: "Common",
            fields: [
                { fieldName: "name", label: "Name", widget: TextField },
                { fieldName: "description", label: "Description", widget: TextField, widgetProps: { multiline: true, rows: 5 }},
                { fieldName: "type", label: "Type", widget: SelectionChoicesField },
                { fieldName: "locale", label: "Locale", widget: LocaleField },
                { fieldName: "isInLibrary", label: "In library", widget: BooleanField },
                { fieldName: "isAssignment", label: "Has a assignment", widget: BooleanField },
                { fieldName: "location", label: "Location", widget: LocationField },
                {
                    fieldName: "copyrights",
                    label: "Copyrights",
                    widget: OptionalOneOfField,
                    widgetProps: {
                        createItem: () => (new Copyrights(null, {}))
                    }
                }
            ]
        },
        {
            label: "Tags",
            fields: [
                {
                    fieldName: "tags",
                    label: "Tags",
                    widget: TagsWidget,
                    widgetProps: {
                        getTags: ({rootStore}) => (["test","test2"])
                    }
                },
            ]
        },
    ]
}

const runnableObjectFormConfigurationsData = {
    "content_objects.model.RunnableObject": commonRunnableObjectBlockConfiguration,
    "content_objects.model.Copyrights": {
        fields: [
            { fieldName: "attribution", label: "Attribution", widget: TextField },
            {
                fieldName: "licenceType",
                label: "Type",
                widget: SelectionChoicesField,
                widgetProps: {
                    clazzDescription: copyrightsClassDescription,
                }
            }
        ]
    }
}


const runnableObjectFormConfigurations = new FormConfigurations(runnableObjectFormConfigurationsData);


const RunnableObjectCommonForm = ({ instance, store }) => {
    return <React.Fragment>
        <FormWidget instance={instance} store={store} formConfigurations={runnableObjectFormConfigurations} />
        <ContentObjectRolesEditor instance={instance} store={store}/>
    </React.Fragment>
}


export default RunnableObjectCommonForm;